import { GreyBlackLabel, HorizontalGreyBlackField } from "components/DataDisplay/GreyBlackField";
import TextInputField from "components/FormElements/Fields/InputFields/TextInputField";
import { longAttributeStyles } from "components/DataDisplay/styles";
import { TextProps, useColorModeValue } from "@chakra-ui/react";
import CDS from "design-system";

export const SUBJECT_FIELD = {
  type: "text",
  label: "Subject",
  placeholder: "Add a subject...",
  name: "subject",
};

interface SubjectFieldProps {
  form: any;
  label?: string;
  labelProps?: object;
  disabled?: boolean;
}

export default function SubjectField({
  form, label, disabled = false, labelProps = {}, ...props
}: SubjectFieldProps) {
  const bg = useColorModeValue("bg.tertiary", "editableBackgroundGrey.dark");
  const {
    formState: { errors },
    register,
  } = form;
  return (
    <TextInputField
      {...SUBJECT_FIELD}
      errors={errors}
      register={register}
      disabled={disabled}
      label={<GreyBlackLabel label={label ?? "Subject"} {...labelProps} />}
      formFieldProps={{
        sideLayout: true,
        labelProps: { display: "flex", alignItems: "flex-end", ...longAttributeStyles.labelContainerProps },
        overrideHelperSpace: true,
      }}
      inputGroupProps={{
        bg,
        _focusWithin: {
          backgroundColor: "inherit",
          border: "1px solid var(--chakra-colors-trixBorderGrey)",
        },
        paddingX: "8px !important",
        borderRadius: "6px",
      }}
      height="32px !important"
      paddingTop="0 !important"
      fontSize="14px"
      variant="unstyled"
      {...props}
    />
  );
}

interface ShowSubjectProps extends TextProps {
  subject: string
}

export function ShowSubject({ subject, ...props }: ShowSubjectProps) {
  return (
    <HorizontalGreyBlackField
      label="Subject"
      labelContainerProps={longAttributeStyles.labelContainerProps}
    >
      <CDS.Text14
        {...props}
      >
        {subject}
      </CDS.Text14>
    </HorizontalGreyBlackField>
  );
}
